import { IsString, IsNotEmpty } from "class-validator";

export class GetOrAssignAccountManagerDto {
  @IsString()
  @IsNotEmpty()
  userId!: string;
}
